// category
export const getCategory = 'master/admin/getcategories'
export const getCategoryById = 'master/admin/getcategoriesbyid';


// products
export const getProductsByCategory = 'master/admin/getproduct';
export const getProductById = 'master/admin/getproductbyID';
